



























import { Utils } from "oweb";
import BaseComponent from "@/components/BaseComponent.vue";
import Croppie from "croppie";
import { Component, Prop, Emit } from "vue-property-decorator";

@Component
export default class WPicEditor extends BaseComponent {
	@Prop(Object)
	options!: Object;
	@Prop(Object)
	outputOptions!: Object;

	croppieInstance = null;
	currentFile = null;
	toRevoke = [];
	isCropping = false;

	get croppie(): any {
		return this.croppieInstance;
	}

	initCroppie() {
		let el = <HTMLElement>this.$refs.croppieContainer;

		el.addEventListener("update", (ev: any) => {
			this.$emit("update", ev.detail);
		});

		let px = Math.min(Math.round(window.screen.width * 0.9), 400),
			def = {
				boundary: {
					width: px,
					height: px
				},
				enableExif: true,
				enableOrientation: true,
				enableZoom: true,
				enableResize: true,
				enforceBoundary: true,
				mouseWheelZoom: true,
				viewport: {
					width: 200,
					height: 200,
					type: "square"
				},
				showZoomer: true
			},
			options = Utils.assign(def, this.options);

		this.croppieInstance = new Croppie(el, options);
	}
	inputChange(e: Event) {
		let el = <HTMLInputElement>e.target;
		if (el.files!.length) {
			this.currentFile = <any>el.files![0];
			let url = <never>URL.createObjectURL(this.currentFile);

			this.toRevoke.push(url);

			this.bind({ url });
			this.isCropping = true;
		}
	}
	bind(options: any) {
		return this.croppie.bind(options);
	}
	destroy() {
		this.croppie.destroy();
	}
	get(cb: (d: any) => void) {
		if (cb) {
			cb(this.croppie.get());
		} else {
			return this.croppie.get();
		}
	}
	rotate(angle: number) {
		this.croppie.rotate(angle);
	}
	setZoom(value: number) {
		this.croppie.setZoom(value);
	}
	refresh() {
		this.croppie.destroy();
		this.initCroppie();
	}

	@Emit("success")
	validate() {
		let ctx = this,
			options = this.outputOptions || { type: "base64" };

		return ctx.croppie.result(options).then(function(output: any) {
			return {
				file: ctx.currentFile,
				data: output
			};
		});
	}

	mounted() {
		this.initCroppie();
	}
	beforeDestroy() {
		this.destroy();
		this.toRevoke.forEach(function(url) {
			URL.revokeObjectURL(url);
		});
	}
}
